"use client";
import React, { useState } from "react";
import AllJobs from "../Home/components/AllJobs";
import Footer from "../Home/components/Footer";

function Vacancies() {
  const [jobTitle, setJobTitle] = useState("");
  const [location, setLocation] = useState("");
  const [salary, setSalary] = useState("");
  const [filteredJobs, setFilteredJobs] = useState({});

  const handleSearch = () => {
    setFilteredJobs({
      jobTitle,
      location,
      salary,
    });
  };

  return (
    <>
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/dist/tabler-icons.min.css"
      />
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Red+Hat+Display:wght@700&family=Epilogue:wght@400;500;700&family=Clash+Display:wght@400;500;700&display=swap"
      />

      <main className="overflow-hidden relative w-full bg-slate-50">
        <section
          className="relative bg-cover bg-center py-16 max-sm:mt-16"
          style={{
            backgroundImage:
              "url(https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80)",
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black via-transparent to-black opacity-50"></div>
          <div className="container mx-auto text-center text-white relative z-10">
            <div className="max-w-2xl mx-auto">
              <h6 className="text-lg">It's simple and smart</h6>
              <h1 className="text-4xl font-bold mt-2">
                Search, Find &amp; Apply
              </h1>
              <p className="text-lg mt-4">
                Browse from more than 15,000,000 adverts while new ones come on
                daily basis
              </p>
              <button className="mt-6 px-6 py-3 bg-indigo-600 text-white rounded-full hover:bg-indigo-800 transition duration-300">
                Read more
              </button>
            </div>
          </div>

          <div className="container mx-auto mt-12 px-4 sm:px-6 lg:px-8 relative z-20">
            <div className="bg-white shadow-lg rounded-lg px-4 py-4 sm:px-6">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                <div className="col-span-1">
                  <input
                    type="text"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    placeholder="Job title"
                    value={jobTitle}
                    onChange={(e) => setJobTitle(e.target.value)}
                  />
                </div>
                <div className="col-span-1">
                  <input
                    type="text"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    placeholder="Location"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                  />
                </div>
                <div className="col-span-1">
                  <input
                    type="text"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    placeholder="Salary"
                    value={salary}
                    onChange={(e) => setSalary(e.target.value)}
                  />
                </div>
                <div className="col-span-1 flex justify-center items-center">
                  <button
                    className="w-full p-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
            <div className="mt-6 px-4 sm:px-0">
              <div className="flex items-center text-white">
                <input
                  type="checkbox"
                  className="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                  defaultChecked
                />
                <label className="ml-2 text-base sm:text-lg">
                  View last searches
                </label>
              </div>
            </div>
          </div>
        </section>
        <AllJobs filteredJobs={filteredJobs} />
        <Footer />
      </main>
    </>
  );
}

export default Vacancies;
